import BB_Header from "./header";
import BB_Cart from "./cart";
import Cookies from "js-cookie";
import anime from "animejs";
import { animate, inView, scroll, stagger } from "motion";
import Splitting from "splitting";

export default class BB_Elements {
    constructor() {
        BB_Elements.search_btn = jQuery(".ob-search-icon");

        BB_Elements.footer_sticky_close_btn = jQuery(".ob-footer-sticky-close-btn");

        BB_Elements.init();
    }
    static init() {
        BB_Elements.search_btn.on("click", BB_Elements.search_toggle);
        // BB_Elements.header_scroll()
        BB_Elements.page_fade();
        BB_Elements.footer_animations();

        // BB_Elements.newsletter_placeholder()
        // BB_Elements.footer_sticky_close_btn.on('click', BB_Elements.footer_sitcky_newsletter_close)
        // BB_Elements.footer_sitcky_newsletter()
    }
    static search_toggle() {
        const search_wrap = jQuery(this).closest(".ob-search-wrap");

        search_wrap.toggleClass("ob-search-active");
    }
    static header_scroll() {
        // header hide
        let lastScrollTop = 0;
        let scrollChecker;
        var $ = jQuery;

        $(window).on("scroll", function (event) {
            var st = $(this).scrollTop();
            var header_scroll_wrap = $(".ob-header-scroll");
            let start_height = 200;
            if (st > start_height) {
                if (st > lastScrollTop) {
                    if (scrollChecker != "down") {
                        header_scroll_wrap.removeClass("ob-header-scroll-active");
                        scrollChecker = "down";
                    }
                } else {
                    if (scrollChecker != "up") {
                        header_scroll_wrap.addClass("ob-header-scroll-active");
                        scrollChecker = "up";
                    }
                }
                lastScrollTop = st;
            } else {
                header_scroll_wrap.removeClass("ob-header-scroll-active");
            }
        });
    }
    static newsletter_placeholder() {
        let newsletter = jQuery(".mailster-email");

        newsletter.attr("placeholder", "email@email.com");
    }
    static footer_sitcky_newsletter() {
        let footer_sticky = jQuery(".ob-footer-sticky");
        let get_cookie = Cookies.get("sitcky_footer_newsletter");

        if (!get_cookie) {
            footer_sticky.removeClass("ob-inactive");
            footer_sticky.addClass("ob-active");
        }
    }
    static footer_sitcky_newsletter_close() {
        let footer_sticky = jQuery(this).closest(".ob-footer-sticky");

        footer_sticky.addClass("ob-inactive");
        footer_sticky.removeClass("ob-active");

        Cookies.set("sitcky_footer_newsletter", 1, { expires: 30 });
        console.log(Cookies.get("sitcky_footer_newsletter"));
    }
    static page_fade() {
        let page_tl = anime.timeline({
            easing: "easeInOutSine",
        });
        page_tl
            .add({
                targets: ".ob-header",
                opacity: [0, 1],
                duration: 600,
                delay: "300",
            })
            .add({
                targets: " #ob-page, #primary, .ob-get-in-touch, #footer",
                opacity: [0, 1],
                duration: 600,
            });
    }
    static footer_animations() {
        Splitting({ target: ".ob-get-in-touch h2" });

        inView(
            ".ob-get-in-touch",
            () => {
                let get_in_touch_words = document.querySelectorAll(
                    ".ob-get-in-touch .ob-heading .word"
                );

                get_in_touch_words.forEach((el, key) => {
                    let chars = el.querySelectorAll(".char");
                    animate(
                       [ [
                            chars,
                            { y: [-30, 0], opacity: [0, 1] },
                            { duration: 0.6, delay: key * 0.3, ease: [0.16, 1, 0.3, 1] },
                        ],
                        [
                            ".ob-get-in-touch .ob-btn",
                            { opacity: [0, 1] },
                            { duration: 0.6, ease: "easeInOut", at: "-0.6" },
                        ]]
                    );
                });
            },
            { amount: 1 }
        );

        inView(
            "#ob-footer",
            () => {
                animate(".ob-get-in-touch-video", { opacity: [0, 0.1] }, { delay: stagger(0.3) });
                animate(
                    ".ob-footer-item",
                    { opacity: [0, 1] },
                    { duration: 1.4, delay: stagger(0.3) }
                );
                animate(".ob-footer-company", { opacity: [0, 1] }, { duration: 1.4, delay: 1.4 });
            },
            { amount: 0.2 }
        );
    }
}
